import { firebaseFirestore } from './firebase';
import { User, Exercise } from './data';
import { getCurrentUser } from './firebaseAuth';

const COLLECTION_USER = "user";
const COLLECTION_EXERCISES = "exercises";

const CACHE_TIME = 1800000;

const request = (req) => {
    return new Promise((resolve) => {
        req.get({ source: 'cache' })
            .then((snapshot) => {
                let cu = window.sessionStorage.getItem('firestoreCacheUntil');
                if (cu === null || cu === undefined) {
                    cu = new Date().getTime() + CACHE_TIME;
                    window.sessionStorage.setItem('firestoreCacheUntil', cu);
                }
                if (cu < new Date().getTime()) {
                    throw new Error('data seems to be too old');
                }
                if (snapshot.exists) {
                    console.log('using cached data');
                    resolve(snapshot.data());
                } else {
                    throw new Error('data not found in cache');
                }
            })
            .catch((error) => {
                console.log(error.message);
                req.get({ source: 'server' })
                    .then((snapshot) => {
                        window.sessionStorage.setItem('firestoreCacheUntil', new Date().getTime() + CACHE_TIME);
                        if (snapshot.exists) {
                            resolve(snapshot.data());
                        } else {
                            throw new Error('data not found on server');
                        }
                    })
                    .catch((error) => { console.error(error); resolve(null) });
            }
            );
    });
}


export default class FirebaseConnector {
    database: firebase.firestore.Firestore = null;

    constructor() {
        if (this.database === null) this.database = firebaseFirestore();
        try { this.database.enablePersistence({ synchronizeTabs: true }); } catch (e) {/*Already enabled*/ }
    }

    /**
     * returns data for the current logged in user
     */
    async getUserData(): User {
        const currentUser = await getCurrentUser();
        if (currentUser) {
            const response = await request(this.database.collection(COLLECTION_USER).doc(currentUser.uid));
            return new User(currentUser, response);
        }
        return null;
    }

    /**
     * returns all exercises
     */
    async getExerciseIds(moderator: Boolean = false): Array<String> {
        const exercises = [];
        const r = await this.database.collection(COLLECTION_EXERCISES).where("shown", "==", !moderator).get();
        r.forEach((element) => {
            exercises.push(element.id);
        });
        return exercises;
    }

    /**
     * Gets an exercise by id
     * @param {String} id id of exercise to get
     */
    async getExercise(id: String): Exercise {
        const response = await request(this.database.collection(COLLECTION_EXERCISES).doc(id));
        if (response !== null) {
            const exercise = response;
            exercise.id = id;
            return exercise;
        }
        return null;
    }

    /**
     * gets all exercises for the ids
     * @param {Array<String>} ids 
     */
    async getExercises(ids: Array<String>): Array<Exercise> {
        const exercises = [];
        for (let i of ids) {
            exercises.push(await this.getExercise(i));
        }
        return exercises;
    }

    /**
     * Updates the rating for a exercise
     * @param {String} id 
     * @param {String} uid 
     * @param {Number} rating 
     */
    async updateRating(id: String, uid: String, rating: Number): void {
        uid = 'ratings.' + uid;
        await this.database.collection(COLLECTION_EXERCISES).doc(id).update({
            [uid]: rating
        });
    }

    async moderatorShow(id: String): void {
        const user = await this.getUserData();
        const roles = await user.getRoles();
        if(roles.moderator) {
            await this.database.collection(COLLECTION_EXERCISES).doc(id).update({
                shown: true
            });
        } else {
            console.warn('Tried to show exercise, but account is not a moderator.');
        }
    }

    async createExercise(e: Exercise): Boolean {
        delete e.id;
        console.log(e);
        try {
            const r = await this.database.collection(COLLECTION_EXERCISES).doc().set(Object.assign({}, e));
            console.log(r);
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }
}